import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import greenRabit from '../../../images/green-rabitt.png';
import Button from '../../../muiComponents/Button';
import Tooltip from '../../../muiComponents/Tooltip';
import LoadingPlaceholder from '../../../muiComponents/LoadingPlaceholder';
import {
    HOTELS_LIST_URL,
    URL_HOTEL_BASE,
    URL_TAB_PARAM,
    ZITONEO,
} from '../../../utils/property/propertyUtils';
import Tabs from './Tabs';
import { tabsData } from '../../../utils/property/propertyUtils';
import {
    useProperty,
    usePropertyFetching,
    usePropertyProgress,
    usePropertySaving,
} from '../../contextsProperty/ContextProperties';
import {
    PROGRESS_MAIN_INFORMATION_TAB,
    PROGRESS_STEP,
} from '../../../types/properties/propertyTypes';
import useTranslate from '../../../customHooks/useTranslate';
import Activity from '../../../layout/header/activity/Activity';

function HeaderYourProperty() {
    const translate = useTranslate();
    const history = useHistory();
    const { handleSave } = usePropertySaving();

    const { name, id } = useProperty();
    const {
        activeStep,
        activeTab,
        activeTabKey,
        progressByStep,
        totalProgress,
    } = usePropertyProgress();
    const { isFetching } = usePropertyFetching();

    const isVisibleSaveAndExitButton = useMemo(() => {
        const isInPresentation = !activeStep || !activeTab;
        const isInZitoneoContent =
            isInPresentation && history.location.pathname.includes(ZITONEO);
        const hasCompletedImportantSteps = totalProgress >= 95;
        const isInMainInfoButNotPropertyTab =
            activeStep === PROGRESS_STEP.MAIN_INFO &&
            activeTabKey !== PROGRESS_MAIN_INFORMATION_TAB.PROPERTY;

        if (isInZitoneoContent) return true;
        if (isInPresentation) return false;
        if (hasCompletedImportantSteps) return true;
        if (isInMainInfoButNotPropertyTab) return false;

        return true;
    }, [activeStep, activeTabKey, totalProgress, history.location.pathname]);

    const comeBacktoList = () => {
        history.push(HOTELS_LIST_URL);
    };

    const comeBackToPresentation = () => {
        history.push(URL_HOTEL_BASE(id));
    };

    const handleClickSave = async () => {
        await handleSave();
        comeBackToPresentation();
    };

    const step = translate(activeStep);

    return (
        <header className='your-property-header__main'>
            <div className='your-property-header__header'>
                <div className='your-property-header__title-container'>
                    <Tooltip titleText={translate('back_to_properties')}>
                        <a href={HOTELS_LIST_URL}>
                            <img
                                src={greenRabit}
                                className='your-property-header__logo'
                                alt='FastPay hotels logo'
                            />
                        </a>
                    </Tooltip>

                    <Tooltip titleText={translate('back_hotel_sumary')}>
                        <h4
                            className='your-property-header__title'
                            onClick={
                                isFetching ? undefined : comeBackToPresentation
                            }
                        >
                            {name}
                            {step && (
                                <span className='font-weight-b'>{step}</span>
                            )}
                        </h4>
                    </Tooltip>
                </div>
                <div className='flex flex-align-center gap-20'>
                    <Activity />
                    <Button
                        variant='text'
                        className='height-fit-content'
                        onClick={comeBacktoList}
                        disabled={isFetching}
                    >
                        {isFetching ? (
                            <LoadingPlaceholder variant='text' width={140} />
                        ) : (
                            translate('back_to_properties')
                        )}
                    </Button>
                    {isVisibleSaveAndExitButton ? (
                        <Button
                            variant='contained'
                            onClick={handleClickSave}
                            disabled={isFetching}
                        >
                            {isFetching ? (
                                <LoadingPlaceholder
                                    variant='text'
                                    width={140}
                                />
                            ) : (
                                translate('save_and_exit')
                            )}
                        </Button>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            {activeStep && (
                <Tabs
                    tabs={tabsData[activeStep].tabs}
                    activeStep={activeStep}
                    activeTab={activeTab}
                    lastCompletedTab={
                        progressByStep[activeStep].lastTabCompleted
                    }
                    onTabChange={(_step, _tab) => {
                        history.push(URL_TAB_PARAM(_tab));
                    }}
                />
            )}
        </header>
    );
}

export default HeaderYourProperty;
